import { Editor } from 'roosterjs-editor-core';
import { changeElementTag, VTable } from 'roosterjs-editor-dom';

export const TABLE_CELL_TAG_NAME = 'TD';
export const TABLE_HEADER_TAG_NAME = 'TH';

export default function setTableHeaderRow(
    editor: Editor,
    node: HTMLTableElement | HTMLTableCellElement,
    hasHeaders: boolean
) {
    if (editor.contains(node)) {
        editor.addUndoSnapshot(() => {
            const vTable = new VTable(node);
            vTable.row = 0;
            vTable.forEachCellOfCurrentRow((cell, i) => {
                // Virtual cells' td can be null due to cell merging. Only call change tag if it exists.
                cell.td &&
                    changeElementTag(
                        cell.td,
                        hasHeaders ? TABLE_CELL_TAG_NAME : TABLE_HEADER_TAG_NAME
                    );
            });
        });
    }
}
